var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgExplore = function SvgExplore(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4H10V6H6V4ZM14 4H18V6H14V4ZM13 7H11V15H13V7ZM9 16L10 15V7H6L4 15V19C4 19.5523 4.44772 20 5 20H8C8.55228 20 9 19.5523 9 19V16ZM14 7H18L20 15V19C20 19.5523 19.5523 20 19 20H16C15.4477 20 15 19.5523 15 19V16L14 15V7Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExplore);
export default ForwardRef;